import { Modal, ModalContent } from '@modusign/design-system';
import cx from 'classnames';
import { ReactNode, useEffect, useState } from 'react';

import noop from '@libs/noop';

interface LoadingProgressBarProps {
  children: ReactNode;
  extension: string | null;
  isLoading: boolean;
}

const defaultProps = {
  children: null,
  extension: null,
  isLoading: true,
};

function LoadingProgressBar({ children, extension, isLoading }: LoadingProgressBarProps) {
  const [className, setClassName] = useState('');

  useEffect(() => {
    setTimeout(() => {
      if (isLoading) {
        setClassName('GaugeBar__inner-bar--longtime');
      }
    }, 1000);
  }, [className, isLoading]);

  return (
    <>
      <Modal isOpen={isLoading} maxWidth="sm" onClose={noop}>
        <ModalContent textAlign="center">
          <p className="space-3x">
            잠시만 기다려주세요..
            <br />
            {extension &&
              (extension === 'pdf'
                ? 'PDF 문서를 업로드하고 있습니다.'
                : `${extension.toUpperCase()}문서를 PDF로 변환하고 있습니다.`)}
          </p>
          <div className="GaugeBar">
            <div className={cx('GaugeBar__inner-bar', className)} />
          </div>
        </ModalContent>
      </Modal>
      {children}
    </>
  );
}

LoadingProgressBar.defaultProps = defaultProps;

export default LoadingProgressBar;
